<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<p class="ded2"><span aria-label=" page v. " epub:type="pagebreak" id="page_v" role="doc-pagebreak">To my husband, Tim—who is teaching me that “the M word” can be a good word—and to my editor, Jean Karl—who changed her initial “no” to “yes.”</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5ee02d35